import { atom } from "recoil";

export const tourSteps = atom({
  key: "tourSteps",
  default: {
    step: 0,
    isAcitve: false,
  },
});
